import { useTriggerEventContext } from '@components/utils/contexts/TriggerEventContext';
import LinkButton from '@components/utils/cta/linkButton';
import styled from '@emotion/styled';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
} from '@enums';
import { Enum_Modals_Trigger } from '@graphql/generated/graphql';
import { StoryPageCta } from '@lib/pimster-stories/types';
import { Button } from '@lib/uikit';

import { useStoryContext } from '../contexts/StoryContext';

interface Props {
    cta: StoryPageCta;
}

const Center = styled.div`
    display: flex;
    justify-content: center;
`;

function getDomain(url: string): string {
    const domain = url.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0];
    return domain;
}

export const CtaHandler = ({ cta }: Props) => {
    const { onTriggerEvent } = useTriggerEventContext();
    const { story } = useStoryContext();

    switch (cta.__typename) {
        case 'ComponentCtaEventCallToAction':
            return (
                <Center>
                    <Button
                        colorScheme='white'
                        onClick={() => {
                            onTriggerEvent({
                                event: Enum_Modals_Trigger.CtaClick,
                                filters: {
                                    text: cta.Text,
                                    storySlug: story?.Slug,
                                },
                            });
                        }}
                    >
                        {cta.Text}
                    </Button>
                </Center>
            );

        case 'ComponentCtaLinkCallToAction':
            return (
                <Center>
                    <LinkButton
                        colorScheme='white'
                        variant='solid'
                        url={cta.Url}
                        text={cta.Text}
                        type={cta.Redirection_Type}
                        destinationName={getDomain(cta.Url)}
                        destinationCategory={
                            OutboundLinkDestinationCategory.Unknown
                        }
                        context={OutboundLinkContext.StoryPage}
                        shape={OutboundLinkShape.Button}
                    />
                </Center>
            );

        default:
            return null;
    }
};
